<template>
  <div></div>
</template>

<script>

import firebase from 'firebase';

export default {
  name: 'LogoutPage',
  created() {
    firebase.auth().signOut();
    this.$router.push({ name: 'login' });
  },
};

</script>



// WEBPACK FOOTER //
// src/containers/LogoutPage.vue